import React, { useState } from "react";
import styles from "../../assets/styles/Feedback/Feedback.module.scss";
import { Formik } from "formik";
import { MimaButton, MimaDropdown, MimaInput, MimaText, ReceiptCheckBox as RCB, Modal } from "../../components";
import moment from "moment";
import { feedbackStore } from "../../stores";


const ConfigFeedback = ({
    loading,
    onSubmit,
    closeModal,
    validationSchema,
}) => {

    const featureList = feedbackStore.feedbackKey.filter(y => y.status === true).map(x => {
        return {
            key: x.key,
            value: x.key
        }
    })

    return (
        <Modal closeModal={closeModal}>
            <MimaText variant="subtitleBold" align="center" mb="7">Feedback Configuration</MimaText>
            <Formik
                initialValues={{
                    tag: "NEW",
                    key: "",
                    status: true
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    touched
                }) => (
                    <>

                        <div className={styles.rcb}>
                            <MimaText variant="small" mb={2} mt={2} >
                                Type of feedback feature
                            </MimaText>
                            <div className="modal__beside">
                                <RCB
                                    title="New"
                                    name="tag"
                                    onChange={() => { setFieldValue('tag', 'NEW') }}
                                    checked={values.tag === 'NEW'}
                                    value="NEW"
                                    error={touched.tag && errors.tag}
                                />
                                <RCB
                                    title="Improvement"
                                    name="tag"
                                    checked={values.tag === 'IMPROVEMENT'}
                                    onChange={() => setFieldValue('tag', 'IMPROVEMENT')}
                                    value="IMPROVEMENT"
                                    error={touched.tag && errors.tag}
                                />
                            </div>
                        </div>
                        {values.tag === "NEW" && (
                            <MimaInput
                                labelTitle="Feature"
                                name="key"
                                placeholder="Enter Feature"
                                value={values.key}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.key}
                                touched={touched.key && errors.key}

                            />
                        )}
                        {values.tag !== "NEW" && (
                            <MimaDropdown
                                labelTitle="Feature"
                                name="key"
                                placeholder="Select Feature"
                                value={values.key}
                                data={featureList}
                                onChange={(data) => {
                                    setFieldValue("key", data.key)
                                }}
                                onBlur={handleBlur}
                                error={errors.key}
                                touched={touched.key && errors.key}

                            />
                        )}

                        {values.tag === "NEW" && (
                            <div className={styles.rcb}>
                                <MimaText variant="small" mb={2} mt={2} >
                                    Activate feedback
                                </MimaText>
                                <div className="modal__beside">
                                    <RCB
                                        title="Yes"
                                        name="status"
                                        checked={values.status === true}
                                        onChange={() => { setFieldValue('status', true) }}
                                        value={values.status}
                                        error={touched.status && errors.status}
                                    />
                                    <RCB
                                        title="No"
                                        name="status"
                                        checked={values.status === false}
                                        onChange={() => setFieldValue('status', false)}
                                        value={values.status}
                                        error={touched.status && errors.status}
                                    />
                                </div>
                            </div>
                        )}

                        <MimaButton
                            title="Save"
                            width={38}
                            onClick={handleSubmit}
                            loading={loading}
                        />
                    </>
                )}

            </Formik>

        </Modal>
    )
}
export default ConfigFeedback;